import Image from 'next/image';
import { Body, Box, Button, Heading } from '@iris/react-components';
import { sendClick } from 'reaxl-analytics';
import { akamaiLoader } from '../../../utils';
import { atcBaseUrl } from '../../constants/config';

const sellMyCarUrl = `${atcBaseUrl}/sell-my-car`;
const sellYourCarText = 'Sell Your Car';
const verifiedBuyersText = 'Chat directly with verified buyers, schedule test drives, and sell online from the comfort of your home.';
const createYourAdButtonText = 'Create Your Ad';

export default function SellYourCarModal() {

  // Pixall Event C6. Create Your Ad Button
  const onCreateYourAdButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const pixallData = {      
      hasListingType: false,
      label: 'cta::create-your-ad',
      eventSource: 'button',
      pageId: 'slp_psx_buy',
      cdl: {
        event: {
          action: 'Click',
          element: 'Create Your Ad Button',
          tagIndex: 'psx-125',
        },
      },
    };
    sendClick('sycClickEvent', event, {
      isPixallEvent: true,
      pixallData,
    });
    queueMicrotask(() => {
      globalThis.location.href = sellMyCarUrl;
    });
  };
  return (
    <Box className="new-sell-your-car-section" data-testid="sell-your-car-section">
      <Box className="new-sell-container">
        <Box className="new-sell-card">
          <Box className="new-sell-logo">
            <Image
              loader={akamaiLoader}
              src="private-exchange-logo.svg"
              alt="Private Seller Exchange"
              width={150}
              height={26}
            />
          </Box>
          <Heading as="h2" size="xl" className="new-sell-heading">{sellYourCarText}</Heading>
          <Body as="p" size="lg" className="new-sell-description">{verifiedBuyersText}</Body>
          <Box className="new-sell-cta iris:w-full iris:md:w-auto">
            {/* Native form so JS-off users still navigate to /sell-my-car. */}
            <form action={sellMyCarUrl} method="get" className="iris:w-full iris:md:w-auto">
              <Button
                type="submit"
                variant="primary"
                inverse
                className="new-create-ad-button iris:w-full iris:md:w-auto"
                onClick={onCreateYourAdButtonClick}
                data-testid="create-ad-button"
              >
                {createYourAdButtonText}
              </Button>
            </form>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
